import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-incoming-mail-icon',
  templateUrl: './communication-incoming-mail.component.html'
})
export class CommunicationIncomingMailComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
